import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_MEDICINE } from './queries';

import { CLIENTS } from 'app/src/components/Clients/queries';

export const FIELDS = {
  clientId: {
    label: 'Client',
    type: 'hidden',
    rules: { required: true },
  },
  name: {
    label: 'Name',
    rules: { required: true },
  },
  alternateNames: {
    label: 'Alternate Name(s)',
    hint: 'For example, a generic name or alternate brand name',
  },
  emoji: {
    label: 'Emoji',
    rules: {
      pattern: {
        value: /^[\p{Emoji}\w]{0,1}$/u,
        message: 'Only one emoji or letter allowed',
      },
    },
  },
  doseAmount: {
    label: 'Dose Amount',
  },
  doseType: {
    label: 'Dose Type',
    blank: 'null',
    select: ['', 'mg', 'gm', 'ml', 'application', 'capsule', 'tablet']
      .map(option => ({ value: option, label: option })),
  },
  startOn: {
    label: 'Started Taking Date',
    type: 'date',
    blank: 'null',
  },
  endOn: {
    label: 'Stopped Taking Date',
    type: 'date',
    blank: 'null',
  }
};

const NewMedicine = ({ onCreated, clientId }) => {
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors }, watch } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: { client: { id: clientId } }
    })
  });

  const { data: selects } = useQuery(CLIENTS, {
    variables: { limit: 100000, offset: 'MA==', options: {} }
  });

  const [createMedicine] = useMutation(CREATE_MEDICINE, {
    onCompleted: data => {
      if (onCreated) {
        onCreated(data.createMedicine.medicine);
      } else {
        navigate('/medicines');
      }
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    createMedicine({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.clientId = {
      ...fields.clientId,
      type: 'select',
      select: [
        { value: '', label: '--Choose--' },
        ...selects.clients.edges
          .map(edge => ({ value: edge.node.id, label: edge.node.name }))
      ],
    };
  }

  return (
    <View>
      <Title>Add Medication</Title>

      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewMedicine;
